import { toast } from "sonner";
import { api } from "@/lib/api";

// Server blurs card/ID numbers (+ watermark for ads, Findloop-photo check for finders).
export async function securePhoto(dataUrl, purpose, t) {
  try {
    const r = await api("/photos/secure", { method: "POST", auth: false, body: { image: dataUrl, purpose } });
    toast.success(t("ph.secured"));
    return r.image;
  } catch (e) {
    toast.error(e.message === "findloop_photo_already_published" ? t("ph.alreadyFindloop") : e.message);
    return null;
  }
}
